import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatosEstadoNomina } from '../../../models/datos-estadoNomina';
import { PersonalService } from '../../../services/personal.service';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatDialog } from '@angular/material/dialog';
import { ErroresService } from '../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MyValidations } from '../../../utils/my-validations';
import { MomentSetService } from '../../../core/services/moment-set.service';

declare var jQuery:any;

@Component({
  selector: 'app-datos-estado-nomina',
  templateUrl: './datos-estado-nomina.component.html',
  styleUrls: ['./datos-estado-nomina.component.css']
})
export class DatosEstadoNominaComponent implements OnInit, OnChanges {
  
  @Input() personalRelacion;
  @Input() legajo;
  
  disabledEditing:boolean=true;
  db:DatosEstadoNomina = new DatosEstadoNomina();

  isEditing: boolean = false;
  isHistory: boolean = false;
  permisoEdicion: boolean = false;

  datosPersonalesForm: FormGroup;
  
  areEditing = false;

  public cargaCompleta: boolean = false;

  constructor(
    //private configDataSrv: ConfigDataService,
    private personalSrv: PersonalService,
    private config: PrimeNGConfig,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private erroresService: ErroresService,
    private momentService: MomentSetService) { }

  get f() { return this.datosPersonalesForm.controls; }

  ngOnInit(): void {
    this.buildFrom();
    this.setFormState(true);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Estado Nomina")) this.permisoEdicion = true;
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  buildFrom(){
    this.datosPersonalesForm = this.formBuilder.group({
      id: [this.personalRelacion.id, Validators.required],
      legajo: [this.personalRelacion.legajo],
      bloqueado: [this.personalRelacion.bloqueado],
      liquidarDesde: [''],
      liquidarHasta: ['', [MyValidations.fecHastaMenor3]],
      ultimaLiquidacion: [''],
      retroactividad: ['']
      
    });    
    if (this.personalRelacion.liquidarDesde != null) {
      this.datosPersonalesForm.get('liquidarDesde').patchValue(new Date(this.personalRelacion.liquidarDesde));  
    }
    if (this.personalRelacion.liquidarHasta != null) {
      this.datosPersonalesForm.get('liquidarHasta').patchValue(new Date(this.personalRelacion.liquidarHasta));
    }
    if (this.personalRelacion.ultimaLiquidacion != null) {
      this.datosPersonalesForm.get('ultimaLiquidacion').patchValue(new Date(this.personalRelacion.ultimaLiquidacion));
    }
    if (this.personalRelacion.retroactividad != null) {
      this.datosPersonalesForm.get('retroactividad').patchValue(new Date(this.personalRelacion.retroactividad));
    }
  }

  setFormState(state: boolean){
    if(!state){
      this.datosPersonalesForm.controls['id'].enable();
      this.datosPersonalesForm.controls['legajo'].enable();
      this.datosPersonalesForm.controls['bloqueado'].enable();
      this.datosPersonalesForm.controls['liquidarDesde'].enable();
      this.datosPersonalesForm.controls['liquidarHasta'].enable();
      this.datosPersonalesForm.controls['ultimaLiquidacion'].disable();
      this.datosPersonalesForm.controls['retroactividad'].disable();

    }else{
      this.datosPersonalesForm.controls['id'].disable();
      this.datosPersonalesForm.controls['legajo'].disable();
      this.datosPersonalesForm.controls['bloqueado'].disable();
      this.datosPersonalesForm.controls['liquidarDesde'].disable();
      this.datosPersonalesForm.controls['liquidarHasta'].disable();
      this.datosPersonalesForm.controls['ultimaLiquidacion'].disable();
      this.datosPersonalesForm.controls['retroactividad'].disable();
    }
    this.cargaCompleta = true;
  }

  CancelChange(e: boolean){
    this.disabledEditing = true;
    this.isEditing = false;
    this.setFormState(this.disabledEditing);
    this.buildFrom();
  }
  
  EditChange(e: boolean){
    this.disabledEditing = false;
    this.isEditing = true;
    this.setFormState(this.disabledEditing);
  }

  SaveChange(e: boolean)
  {
    let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
      width: '400px'
    });
    dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

    let datos: DatosEstadoNomina = {
      id: this.datosPersonalesForm.value.id,
      legajo: this.datosPersonalesForm.value.legajo,
      bloqueado: this.datosPersonalesForm.value.bloqueado,
      liquidarDesde: this.momentService.saveDateServer(this.datosPersonalesForm.value.liquidarDesde, false),
      liquidarHasta: this.momentService.saveDateServer(this.datosPersonalesForm.value.liquidarHasta, false),
      ultimaLiquidacion: this.momentService.saveDateServer(this.datosPersonalesForm.value.ultimaLiquidacion, false),
      retroactividad: this.momentService.saveDateServer(this.datosPersonalesForm.value.retroactividad, false)
    };

    this.personalSrv.SaveDatosEstadoNomina(datos).subscribe(
      data =>
      {
        setTimeout(function ()
        {
          dialogProcesandoRef.close();
        });

        this.snackBar.open("Datos Estado Nómina guardado", "OK", { duration: 10000 });

        this.disabledEditing = true;
        this.isEditing = false;
        this.setFormState(this.disabledEditing);
      },
      error => {
        dialogProcesandoRef.close();
        this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
      });
  }
}
